import { isAnyArray } from 'is-any-array';
export function checkNumberOrArray(data) {
    if (!isAnyArray(data) || isAnyArray(data[0])) {
        throw new Error(`x and y data should be an array of numbers`);
    }
}
//# sourceMappingURL=checkNumberOrArray.js.map